const api="AIzaSyB_j8mFHURlepqlPq4oOLh5zf3rlyFmyyM"

import {
    GoogleGenerativeAI,
    HarmCategory,
    HarmBlockThreshold,
  } from "@google/generative-ai"
  
  
  const genAI = new GoogleGenerativeAI(api);
  
  const model = genAI.getGenerativeModel({
    model: "gemini-2.5-flash",
  });
  
  const generationConfig = {
    temperature: 1,
    topP: 0.95,
    topK: 40,
    maxOutputTokens: 8192,
    responseMimeType: "text/plain",
  };
  
  async function run(prompt, history = [], personaInstruction = "", systemPrompt = "") {
    // System / identity messages (avoid exposing provider details)
    const systemIntro = [
      systemPrompt ? { role: "user", parts: [{ text: systemPrompt }] } : null,
      personaInstruction ? { role: "user", parts: [{ text: personaInstruction }] } : null,
      { role: "model", parts: [{ text: "Hello! I'm VedaTron-AI. How can I help you today?" }] }
    ].filter(Boolean);

    const chatSession = model.startChat({
      generationConfig,
      history: [...systemIntro, ...history],
    });

    try {
  const result = await chatSession.sendMessage(prompt);
      console.log(result.response.text());
      return result.response.text()
    } catch(err){
      // Provide a normalized error object
      const status = err?.status || err?.code || 500;
      const message = err?.message || 'Unknown error communicating with model.';
      throw { status, message };
    }
  }
  
  export default run;